/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Card, Skeleton, SkeletonProps, Stack } from "@mui/material";
import { FC, type JSX } from "react";

import TestIds from "../../../../testIds";

const RectangularSkeleton = (props: SkeletonProps) => (
  <Skeleton variant="rectangular" height={8} width="20%" {...props} />
);

const ActivitiesListLoadingDisplay: FC = (): JSX.Element => {
  return (
    <Stack
      flex={1}
      gap={2}
      alignItems="stretch"
      data-testid={TestIds.feat.activities.activitiesList.loading}
    >
      {[1, 2, 3].map((item) => (
        <Card
          key={item}
          variant="outlined"
          sx={{ borderRadius: "16px", p: 2 }}
          className="farmlands-v2"
        >
          <Stack gap={2} direction="column">
            <RectangularSkeleton width="60%" height={20} />
            <RectangularSkeleton width="100%" />
            <RectangularSkeleton width="40%" />
            <Stack direction="row" gap={4} paddingTop={2}>
              <RectangularSkeleton />
              <RectangularSkeleton />
              <RectangularSkeleton />
            </Stack>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};

export default ActivitiesListLoadingDisplay;
